import { useEffect, useState } from "react";

const DEFAULT_WIDTH = 1024;

interface ViewportWidthOptions {
	fallbackWidth?: number;
}

export const useViewportWidth = ({ fallbackWidth = DEFAULT_WIDTH }: ViewportWidthOptions = {}) => {
	const [width, setWidth] = useState(fallbackWidth);

	useEffect(() => {
		if (typeof window === "undefined") return;
		const handleResize = () => setWidth(window.innerWidth);
		handleResize();
		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	return width;
};

export const useIsMobile = ({
	breakpoint = 768,
	fallbackWidth = DEFAULT_WIDTH,
}: ViewportWidthOptions & { breakpoint?: number } = {}) => {
	const width = useViewportWidth({ fallbackWidth });
	return width < breakpoint;
};
